import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseDrawerComponent } from '@fuse/components/drawer/drawer.component';

@NgModule({
    imports: [CommonModule, FuseDrawerComponent],
    exports: [FuseDrawerComponent],
})
export class FuseDrawerModule {}
